import { YPaymentAmount } from '../y/amount';
import { $api } from '../y/api';
import { makeDataStore } from '../y/data-store';
import { YI18NString } from '../y/i18n';
import { $time } from '../y/time';
import { YId, YTimeString } from '../y/types';
import { UMediaLink } from './u-media-link';

export interface IProvider {
    id: YId;
    producer_id: YId;
    engine: string;
    connection: string;
    is_active: boolean;
}

export interface ISession {
    id: YId;
    event_id: YId;
    foreign_id: string;
    is_drop_in: boolean;
    time: YTimeString;
    end_time?: YTimeString;
    duration?: number;
    base_price?: YPaymentAmount;
}

export interface IEvent {
    id: YId;
    provider_id: YId;
    foreign_id: string;
    producer_id: YId;
    venue_id?: YId;
    scene_id?: YId;
    tag_ids: YId[];
    keywords: string[];
    name?: YI18NString;
    description?: YI18NString;
    fields: Record<string, YI18NString>;
    media_links: UMediaLink[];
    picture_urls: string[];
    picture_ids: YId[];
    provider_data: Record<string, any>;
}

export interface IEventAdminView extends IEvent {
    sessions: ISession[];
}

export const i_events = makeDataStore('i/events', 'i/event', (m: IEventAdminView) => m, Object.assign);
export const i_providers = makeDataStore('i/providers', 'i/provider', (m: IProvider) => m, Object.assign);

export function iEventGetNextSession(event: IEventAdminView) {
    const sessions = [...event.sessions];
    sessions.sort((a, b) => $time.compare($time(a.time), $time(b.time)));
    const now = $time.now();
    for(const s of sessions) {
        if($time(s.time).after(now))
            return s;
    }

    return;
}

export function iEventGetActiveSessions(event: IEventAdminView) {
    return event.sessions.filter(s => $time(s.time).after($time.now()));
}

export function iEventGetNextOrFirstTime(event: IEventAdminView) {
    const next = iEventGetNextSession(event);
    if(next)
        return $time(next.time);
    if(event.sessions.length)
        return $time(event.sessions[0].time);
    return;
}

export function iEventLink(event_id: YId, imported_id: YId) {
    return $api.POST('i/event/' + imported_id + '/link', { event_id: event_id });
}
